import { useEffect, useState } from "react";
import axiosInstance from "../../variables/api/axiosInstance";
import BarreBottom from "./BarreBottom";

export const DocumentFooter = ({
    backgroundColor = '#ffffff',
    textColor = '#1e3a8a'
}) => {
    const [insurances, setInsurances] = useState([]);
    const {
        telephone,
        whatsapp,
        telecopie,
        nrc,
        nif
    } = {
        telephone: '+228 92-62-66-66',
        whatsapp: '+228 70-48-11-11',
        telecopie: '+228 22-20-55-80',
        nrc: '2009 C 0771',
        nif: '1000 16 1028'
    };

    useEffect(() => {
        axiosInstance.get(`/api/organisme/all/assurances`).then(response => {
            if (response.data) {
                // console.log("Logos des assurances récupérés:", response.data);
                // Mettre à jour les logos des assurances avec les données récupérées
                setInsurances(response.data);
            }
        }).catch(error => {
            console.error("Erreur lors de la récupération des logos des assurances:", error);
        });
    }, []);

    return (
        <div
            style={{ backgroundColor, color: textColor, marginTop: '0px' }}
        >
            <BarreBottom />
            {/* Section informations de contact */}
            <div className="px-2 py-1">
                <div className="flex items-center justify-center text-sm font-medium whitespace-nowrap" style={{ fontSize: '9px' }}>
                    <div className="flex items-center gap-4 text-center whitespace-nowrap">
                        {telephone && (
                            <span>Tél: {telephone}</span>
                        )}
                        {whatsapp && (
                            <span> | Whatsapp: {whatsapp}</span>
                        )}
                        {telecopie && (
                            <span> | Télécopie: {telecopie}</span>
                        )}
                        {nrc && (
                            <span> | N°RC: {nrc}</span>
                        )}
                        {nif && (
                            <span> - N°COE: {nif}</span>
                        )}
                    </div>
                </div>
            </div>


            {/* Section logos des assurances */}
            <div className="px-2 py-1 bg-white" style={{ marginTop: '-10px' }} >
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'nowrap', // C'est la propriété clé pour empêcher le retour à la ligne
                    overflowX: 'auto' // Ajoute un défilement horizontal si nécessaire
                }}>
                    {insurances?.map((insurance, index) => (
                        <div key={index}>
                            <img
                                src={`data:image/png;base64,${insurance.logoDisplay}`}
                                alt={insurance.raisonSociale || `Logo ${index + 1}`}
                                className="h-12 w-auto object-contain hover:scale-105 transition-transform duration-200"
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                }}
                                style={{
                                    flexShrink: 0, // Empêche l'image de rétrécir
                                    maxWidth: '100px', // ou une autre valeur pour limiter la taille
                                    height: '48px' // Correspond à h-12 (12 * 4px = 48px)
                                }}
                            />
                        </div>
                    ))}
                </div>
                {/* Mention légale */}
                <div className="text-center mt-2" style={{ fontWeight: 'bold', fontSize: '15px', color: textColor }}>
                    Entreprises régies par le code des assurances
                </div>
            </div>
        </div>
    );
};
